import { render, staticRenderFns } from "./DigitalWorld.vue?vue&type=template&id=c47fef74&scoped=true&"
import script from "./DigitalWorld.vue?vue&type=script&lang=js&"
export * from "./DigitalWorld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47fef74",
  null
  
)

export default component.exports